import React from "react";
import PropTypes from "prop-types";
import { Button } from "shards-react";
import Graph from "react-graph-vis";


import Chart from "../../utils/chart";
const axios = require('axios').default;

var options = {
    autoResize: true,
    height: '100%',
    width: '100%',
    // layout: {
    //   hierarchical: false,
    //   improvedLayout:false
    // },
    nodes: {
      shape: 'dot',
      scaling: {
        min: 5,
        max: 10
      },
      radius:2,
      font: {
        size: 20,
        face: 'Tahoma',
        color: "#f4f4f4",
      },
      shapeProperties: {
        interpolation: false    // 'true' for intensive zooming
      }
    },
    edges: {
      width: 0.15,
      color: "#f4f4f4",
      smooth: {
        type: 'continuous'
      }
    },
    // physics: {
    //   stabilization: false,
    //   barnesHut: {
    //     gravitationalConstant: -80000,
    //     springConstant: 0.001,
    //     springLength: 200
    //   }
    // },
    interaction: {
      tooltipDelay: 200,
      hideEdgesOnDrag: true
    },

    physics: {
        adaptiveTimestep: true,
        barnesHut: {
            gravitationalConstant: -8000,
            springConstant: 0.04,
            springLength: 95
        },
        stabilization: {
            iterations: 2000
        }
    },
    layout: {
        randomSeed: 191006,
        improvedLayout: true
    }
  };


// var graph1 = {
//   };

// const options = {
//     autoResize: true,
//     height: '100%',
//     width: '100%',
//     layout: {
//       hierarchical: false,
//       improvedLayout:false
//     },
//     edges: {
//       color: "#f4f4f4"
//     },
//     nodes: {
//         shapeProperties: {
//           interpolation: false    // 'true' for intensive zooming
//         }
//       },
//       physics: {
//         enabled: true,
//         solver: "forceAtlas2Based",
//         stabilization: {
//           enabled: false // This is here just to see what's going on from the very beginning.
//         }
//       }
    

//     // height: "500px"
//   };

class SocialNetworkAll extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            graph3: []
          };
        
        this.chartData = null;
        this.canvasRef = React.createRef();
        this.graph1 = {
            nodes: [],
            edges: [
            ]
          };
        

    }

    componentDidMount() {
        this.graph1 = this.intializeChart();
    }

    intializeChart = () => {
        axios.get(`data/topic${this.props.topicId}_network_graph.json`) // data/topicsData1.json
            .then(response => {
                
                this.chartData = { ...response.data.chartData };
                console.log(123345, this.chartData);
                // console.log(this.graph1);
                this.graph1 = this.chartData;
                this.setState({ 
                    graph3: this.chartData
                  });

                
                // console.log(999, this.graph3);

                this.buildChart();
                
            })

       return this.chartData;
    }

    buildChart = () => {

        this.chart = new Graph(this.canvasRef.current, {
            // type: "LineWithLine",
            // data: this.chartData
            
        });


        // this.chart = new Chart(this.canvasRef.current, {
        //     type: "LineWithLine",
        //     data: this.chartData
            
        // });



        // Render the chart.
        this.chart.render();

    }



    render() {
        return (
            <div className="py-0 my-0">
                <canvas
                    height="0"
                    ref={this.canvasRef}
                    style={{ maxWidth: "100% !important" }}
                    
                />
             
                <Graph graph={this.graph1} options={options} style={{ height: "1280px" }} />
     
                {/* <Graph graph={this.chartData} style={{ height: "640px" }} /> */}
     

            </div>

            
        );
    }
}

SocialNetworkAll.propTypes = {

};

SocialNetworkAll.defaultProps = {
    title: "Popular Fake News on Twitter",
};

export default SocialNetworkAll;









// import React, { useState, useEffect } from 'react';
// // import PropTypes from "prop-types";

// import Graph from "react-graph-vis";
// // import { Container, Row, Col,Badge, Button, Card, CardHeader, CardBody } from "shards-react";



// const axios = require('axios').default;


// const graph = {
//     nodes: [
//       {
//         id: 138956299,
//         label: "LonestarTravis",
//         influence_score: 4,
//         color: "#e74c3c"
//       },
//       {
//         id: 169074496,
//         label: "rfhyde1",
//         influence_score: 32,
//         color: "#e74c3c"
//       },
//       {
//         id: 21482782,
//         label: "lisarntx",
//         influence_score: 0,
//         color: "#bdc3c7"
//       },
//       {
//         id: 21534954,
//         label: "bryanmclemore",
//         influence_score: 0,
//         color: "#bdc3c7"
//       },
//       {
//         id: 30976723,
//         label: "tnhwyman",
//         influence_score: 0,
//         color: "#bdc3c7"
//       },
//       {
//         id: 1270797782119481351,
//         label: "RankinRitz",
//         influence_score: 0,
//         color: "#bdc3c7"
//       },
//       {
//         id: 818471525896650753,
//         label: "Tx_PatriotMom",
//         influence_score: 0,
//         color: "#bdc3c7"
//       },
//       {
//         id: 462901926,
//         label: "jimdad1967",
//         influence_score: 6,
//         color: "#e74c3c"
//       },
//       {
//         id: 2983205608,
//         label: "boscolouisa",
//         influence_score: 0,
//         color: "#bdc3c7"
//       },
//       {
//         id: 904987818,
//         label: "GrampTorino",
//         influence_score: 0,
//         color: "#bdc3c7"
//       },
//       {
//         id: 715037396438552579,
//         label: "islanderkim1",
//         influence_score: 0,
//         color: "#bdc3c7"
//       },
//       {
//         id: 713522523489570817,
//         label: "Yolanda53311253",
//         influence_score: 0,
//         color: "#bdc3c7"
//       },
//       {
//         id: 2356586227,
//         label: "0ShineDiamond0",
//         influence_score: 10,
//         color: "#e74c3c"
//       },
//       {
//         id: 1206937304683745282,
//         label: "Dom67245896",
//         influence_score: 2,
//         color: "#e74c3c"
//       },
//       {
//         id: 609909059,
//         label: "WilliamArnold45",
//         influence_score: 0,
//         color: "#bdc3c7"
//       }
//     ],
//     edges: [
//       {
//         from: 169074496,
//         to: 21482782
//       },
//       {
//         from: 169074496,
//         to: 21534954
//       },
//       {
//         from: 169074496,
//         to: 30976723
//       },
//       {
//         from: 169074496,
//         to: 1270797782119481351
//       },
//       {
//         from: 169074496,
//         to: 818471525896650753
//       },
//       {
//         from: 462901926,
//         to: 2983205608
//       },
//       {
//         from: 169074496,
//         to: 904987818
//       },
//       {
//         from: 169074496,
//         to: 715037396438552579
//       },
//       {
//         from: 169074496,
//         to: 713522523489570817
//       },
//       {
//         from: 2356586227,
//         to: 2356586227
//       }
//     ]
//   };
  
//   class SocialNetwork extends React.Component {
//     constructor(props) {
//       super(props);
//       this.chartData = null;
//       this.canvasRef = React.createRef();
//     }
  
//     componentDidMount() {
//       console.log(1);
//       this.intialize();
//     }
  
//     intialize = () => {
      
//       axios.get(`http://35.167.79.21/data/topic22_network_graph.json`) // data/topicsData1.json
//         .then((response) => {
          
//           this.chartData = { ...response.data.chartData };
//           console.log(12, this.chartData.nodes);
//           // this.chartData = { ...response.data.chartData };
//           // this.fullChartData = { ...response.data.chartData };
//           // this.tweetData = response.data.chartData.datasets[0].data;
//         });

//         console.log(100, this.chartData);
//     };
  
//     render() {
//       return (
//         <div className="note">
//           <h1></h1>
//           <h1>React graph vis</h1>
//           <Graph graph={graph} style={{ height: "640px" }} />
//         </div>
//       );
//     }
//   }
  
//   export default SocialNetwork;




// // class Influence extends React.Component {
// //     constructor(props) {
// //         super(props);
// //         this.minLength = -this.minLength; //-(14 * 24 * 4)--> //14 days
// //         this.fullChartData = null;
        
// //         this.chartData = null;
// //         this.chartStart = this.minLength;
// //         this.chartEnd = -1;
// //         this.maxCnt = 1000;
// //         this.tweetData = null; 
// //         this.canvasRef = React.createRef();


// //         // console.log(Math.max(this.tweetData.length));
// //             // console.log( Math.pow(10, 1+parseInt(Math.log10(Math.max(this.tweetData)))));

// //     }

// //     componentDidMount() {
// //         this.intializeChart();
// //     }

// //     intializeChart = () => {
// //         axios.get(`http://35.167.79.21/data/topic${this.props.topicId}_network_graph.json`) // data/topicsData1.json
// //             .then(response => {
// //                 this.DataAll = { ...response.data.chartData};
// //                 console.log(this.DataAll);
// //                 var G = {};
// //                 G = this.DataAll;
// //                 console.log('11111111',G);
// //                 const graph = {
// //                     nodes: [
// //                       {
// //                         id: 138956299,
// //                         label: "LonestarTravis",
// //                         influence_score: 4,
// //                         color: "#e74c3c"
// //                       },
// //                       {
// //                         id: 169074496,
// //                         label: "rfhyde1",
// //                         influence_score: 32,
// //                         color: "#e74c3c"
// //                       },
// //                       {
// //                         id: 21482782,
// //                         label: "lisarntx",
// //                         influence_score: 0,
// //                         color: "#bdc3c7"
// //                       },
// //                       {
// //                         id: 21534954,
// //                         label: "bryanmclemore",
// //                         influence_score: 0,
// //                         color: "#bdc3c7"
// //                       },
// //                       {
// //                         id: 30976723,
// //                         label: "tnhwyman",
// //                         influence_score: 0,
// //                         color: "#bdc3c7"
// //                       },
// //                       {
// //                         id: 1270797782119481351,
// //                         label: "RankinRitz",
// //                         influence_score: 0,
// //                         color: "#bdc3c7"
// //                       },
// //                       {
// //                         id: 818471525896650753,
// //                         label: "Tx_PatriotMom",
// //                         influence_score: 0,
// //                         color: "#bdc3c7"
// //                       },
// //                       {
// //                         id: 462901926,
// //                         label: "jimdad1967",
// //                         influence_score: 6,
// //                         color: "#e74c3c"
// //                       },
// //                       {
// //                         id: 2983205608,
// //                         label: "boscolouisa",
// //                         influence_score: 0,
// //                         color: "#bdc3c7"
// //                       },
// //                       {
// //                         id: 904987818,
// //                         label: "GrampTorino",
// //                         influence_score: 0,
// //                         color: "#bdc3c7"
// //                       },
// //                       {
// //                         id: 715037396438552579,
// //                         label: "islanderkim1",
// //                         influence_score: 0,
// //                         color: "#bdc3c7"
// //                       },
// //                       {
// //                         id: 713522523489570817,
// //                         label: "Yolanda53311253",
// //                         influence_score: 0,
// //                         color: "#bdc3c7"
// //                       },
// //                       {
// //                         id: 2356586227,
// //                         label: "0ShineDiamond0",
// //                         influence_score: 10,
// //                         color: "#e74c3c"
// //                       },
// //                       {
// //                         id: 1206937304683745282,
// //                         label: "Dom67245896",
// //                         influence_score: 2,
// //                         color: "#e74c3c"
// //                       },
// //                       {
// //                         id: 609909059,
// //                         label: "WilliamArnold45",
// //                         influence_score: 0,
// //                         color: "#bdc3c7"
// //                       }
// //                     ],
// //                     edges: [
// //                       {
// //                         from: 169074496,
// //                         to: 21482782
// //                       },
// //                       {
// //                         from: 169074496,
// //                         to: 21534954
// //                       },
// //                       {
// //                         from: 169074496,
// //                         to: 30976723
// //                       },
// //                       {
// //                         from: 169074496,
// //                         to: 1270797782119481351
// //                       },
// //                       {
// //                         from: 169074496,
// //                         to: 818471525896650753
// //                       },
// //                       {
// //                         from: 462901926,
// //                         to: 2983205608
// //                       },
// //                       {
// //                         from: 169074496,
// //                         to: 904987818
// //                       },
// //                       {
// //                         from: 169074496,
// //                         to: 715037396438552579
// //                       },
// //                       {
// //                         from: 169074496,
// //                         to: 713522523489570817
// //                       },
// //                       {
// //                         from: 2356586227,
// //                         to: 2356586227
// //                       }
// //                     ]
// //                   };
                
// //                 this.chartData = { ...response.data.chartData };
// //                 this.fullChartData = { ...response.data.chartData };
                
                
                
// //             })

            
// //     }


// //     render() {
// //         return (
            
// //             <div className="note">
// //       <h1>Social Network</h1>

// //       <Graph graph={this.graph} style={{ height: "640px" }} />
// //     </div>
            
// //         );
// //     }
// // }

// // Influence.propTypes = {
// //     /**
// //      * The component's title.
// //      */
// //     title: PropTypes.string,
// //     /**
// //      * The chart dataset.
// //      */
// //     chartData: PropTypes.object,
// //     /**
// //      * The Chart.js options.
// //      */
// //     chartOptions: PropTypes.object
// // };

// // Influence.defaultProps = {
// //     title: "Popular Fake News on Twitter",
// // };

// // export default Influence;
